import { inject } from '@angular/core';
import { UserMetadataService } from '@core/services/user-metadata.service';

export const userDomainGuard = (requiredDomainId: number): boolean => {
  const userMetaDataService = inject(UserMetadataService);

  return !!userMetaDataService.getDomainById(requiredDomainId);
};
